// removed by extract-text-webpack-plugin
module.exports = {"horizontal":"List__horizontal___RS3MN","commas":"List__commas___316w9","dashes":"List__dashes___2k54N","middot":"List__middot___2YZf8","small":"List__small___Jg_FF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/styles/List.css
// module id = 1128
// module chunks = 4